'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductTileQeId = exports.getCardTileQeId = exports.getProductTitle = exports.getCardTitle = exports.getProducts = exports.getCards = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _dtmLinkAppend = require('acq-components/lib/utils/DTM/dtmLinkAppend');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDtmNavType = function getDtmNavType(link) {
  var navTypeRaw = link.dtm && link.dtm.eventAction ? link.dtm.eventAction : '';
  return [_dtmConsts.DTM_CONSTS.defaultNavType, _dtmConsts.DTM_CONSTS.intLinkNavType].includes(navTypeRaw) ? navTypeRaw : _dtmConsts.DTM_CONSTS.defaultNavType;
};

var processProductUnits = function processProductUnits(unitList, pageDtmInfo) {
  return unitList.map(function (prodUnit) {
    return (0, _extends3.default)({}, prodUnit, {
      links: (prodUnit.links || []).map(function (link) {
        link.url = (0, _dtmLinkAppend.appendLinkNav)(link.url, getDtmNavType(link), pageDtmInfo.linkNavBase, pageDtmInfo.pageName, prodUnit.dtm ? prodUnit.dtm.productName : undefined, link.dtm && link.dtm.eventAsset ? link.dtm.eventAsset : link.key === 'compare' ? 'compare' : undefined);
        return link;
      })
    });
  });
};

var getCards = exports.getCards = (0, _reselect.createSelector)([function (state) {
  return (0, _lodash2.default)(state.intlPage, 'cards') || [];
}, function (state) {
  return (0, _lodash2.default)(state.intlPage, 'dtm') || {};
}], processProductUnits);

var getProducts = exports.getProducts = (0, _reselect.createSelector)([function (state) {
  return (0, _lodash2.default)(state.intlPage, 'products') || [];
}, function (state) {
  return (0, _lodash2.default)(state.intlPage, 'dtm') || {};
}], processProductUnits);

var getCardTitle = exports.getCardTitle = function getCardTitle(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.cardTiles.header') || '';
};

var getProductTitle = exports.getProductTitle = function getProductTitle(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.productTiles.header') || '';
};

var getCardTileQeId = exports.getCardTileQeId = function getCardTileQeId(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.cardTiles.qeId') || '';
};

var getProductTileQeId = exports.getProductTileQeId = function getProductTileQeId(state) {
  return (0, _lodash2.default)(state.intlPage, 'page.productTiles.qeId') || '';
};